var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table"},[_c('Table',{attrs:{"size":"large","columns":_vm.columns12,"data":_vm.list},scopedSlots:_vm._u([{key:"title",fn:function(ref){
var row = ref.row;
return [_c('strong',[_vm._v(_vm._s(row.title))])]}},{key:"action",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('Button',{attrs:{"type":"error","size":"small"},on:{"click":function($event){return _vm.remove(row)}}},[_vm._v("删除")])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }